import React from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import AuditAdminMenu from '../AuditAdminMenu'
import AuditDetailTab from '../AuditDetailTab'
import AuditItemTab from '../AuditItemTab'
import AuditTemplateDetailTab from '../AuditTemplateDetailTab'
import upperCase from 'lodash/upperCase'
import {AuditContext} from '../../context/Audits'
import {TemplatesContext} from '../../context/Templates'
import {AuditPaneContext} from '../../context/AuditPane'
import {UserContext} from '../../context/User'
import {useTranslation} from 'react-i18next'

const statusValues = {
  completed: 'green',
  incomplete: 'green',
  open: 'blue',
}

function AuditSidebar() {
  const {audit} = React.useContext(AuditContext)
  const {template} = React.useContext(TemplatesContext)

  const user = React.useContext(UserContext)
  const [activeTab, setActiveTab] = React.useState(1)
  const paneState = React.useContext(AuditPaneContext)

  const permission = (user.details && user.details.canCreate) || false
  const isTemplate = (paneState.activeTab === 'audit' ? false : true) || false
  const {t} = useTranslation()

  const handleSelect = evtKey => {
    setActiveTab(evtKey)
  }

  const selected = (isTemplate ? template && template.selected : audit && audit.selected) || null

  return (
    paneState.isSidebarOpen &&
    selected && (
      <div className="audit-sidebar">
        <>
          <div className="audit-sidebar__header">
            <div className="width_100 flex_row">
              <div className="audit-sidebar__title">{selected.name}</div>
              <div className="audit-sidebar__menu">
                {permission &&
                  (selected.audit_type_for_user === 'created' ||
                    selected.audit_type_for_user === 'assigned' ||
                    user.details.is_admin) && <AuditAdminMenu data={selected} />}
              </div>
              <div className="action-back">
                <div
                  className="audit-icon--close audit-icon--16 audit-icon--black cursor_pointer ml_8"
                  tabIndex="0"
                  onClick={() => paneState.resetDefault()}
                ></div>
              </div>
            </div>

            {!isTemplate && (
              <b
                className={
                  'audit-sidebar__status' +
                  `${(statusValues[selected.status] &&
                    ` audit-sidebar__status--${statusValues[selected.status]}`) ||
                    ''}`
                }
              >
                {(statusValues[selected.status] &&
                  upperCase(t(`audit.table.status.${selected.status}`))) ||
                  upperCase(t(`audit.table.status.scheduled`))}
              </b>
            )}

            {isTemplate && (
              <h6 className="mb-0 font_12">
                Created by: <span className="font_color_3333">{selected.user_name}</span>
              </h6>
            )}
          </div>
        </>
        {isTemplate ? (
          <AuditTemplateDetailTab template={selected} permission={permission} />
        ) : (
          <Tabs activeKey={activeTab} onSelect={handleSelect} className="audit-sidebar__tabs">
            <Tab eventKey={1} title={t('audit.sidebar.tab-1')}>
              <AuditDetailTab audit={selected} permission={permission} />
            </Tab>
            <Tab eventKey={2} title={t('audit.sidebar.tab-2')}>
              <AuditItemTab audit={selected} />
            </Tab>
          </Tabs>
        )}
      </div>
    )
  )
}

export default AuditSidebar
